import { render, staticRenderFns } from "./SimPhongThuy.vue?vue&type=template&id=6153ea4a&"
import script from "./SimPhongThuy.vue?vue&type=script&lang=js&"
export * from "./SimPhongThuy.vue?vue&type=script&lang=js&"
import style0 from "./SimPhongThuy.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports